module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    staticStyle: {
      "margin-top": "3em"
    },
    attrs: {
      "id": "_idContainer004"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("To my dad and role model,")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Donald Scott")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("1")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("92")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("7")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("—")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("2")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("01")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("—")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("J")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v(".S.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  })]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("To my biggest fan,")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("W")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("orth Kirkman")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("1")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("930—")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("2")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("0")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("1")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("—")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("R")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v(".K.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72871b86","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NoYelling_EPUB-1.vue
// module id = 60
// module chunks = 0